import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'middleEllipsis',
  standalone: true,
})
export class MiddleEllipsisPipe implements PipeTransform {
  transform(value: string | null | undefined, maxLength = 24): string {
    if (!value) return '';
    if (value.length <= maxLength) return value;
    if (maxLength <= 3) return '...';

    const charsToShow = maxLength - 3;
    const startLength = Math.ceil(charsToShow / 2);
    const endLength = Math.floor(charsToShow / 2);

    return `${value.slice(0, startLength)}...${value.slice(-endLength)}`;
  }
}
